module.exports = __webpack_public_path__ + "img/task-setup-nodata2.48f5c1d2.png";